const MenuActionTypes = {
    UPDATE_PROCESOS: 'UPDATE_PROCESOS',
    UPDATE_LISTA_PROCESOS : 'UPDATE_LISTA_PROCESOS',
    UPDATE_DETALLE: 'UPDATE_DETALLE',
    UPDATE_LISTA_ESTADOS: 'UPDATE_LISTA_ESTADOS',
    UPDATE_ESTADO: 'UPDATE_ESTADO',
    UPDATE_LISTA_DISTRITOS: 'UPDATE_LISTA_DISTRITOS',
    UPDATE_DISTRITO: 'UPDATE_DISTRITO',
    UPDATE_RUTA_PUBLICADOR: 'UPDATE_RUTA_PUBLICADOR'
};

export default MenuActionTypes;